<template>
  <section class="logistic-services-section">
    <div class="container">
      <div class="title-box title-wrapper">
        <div class="logistic-title-box wow fadeInLeft" data-wow-duration="2s" data-wow-delay=".5s">
          <span v-bind="$parent.dKey('b5subtitle')" class="section-title">{{subtitle}}</span>
          <h3 v-bind="$parent.dKey('b5title')">{{title}}</h3>
        </div>
        <div class="big-title-box wow fadeInRight" data-wow-duration="2s" data-wow-delay=".5s">
          <span v-bind="$parent.dKey('b5titleRight')" class="big-title-st resp-number">{{bgTitle}}</span>
        </div>
      </div>
      <div class="row solutions-overview-wrapper">
        <div class="col-6 wow fadeIn" data-wow-duration="2s" data-wow-delay=".5s">
          <router-link :event="$root.isAdmin() ? '' : 'click'" v-bind:to="'/' + $root.locale + '/complex#contract-logistics'" class="solution-overview solution-01">
            <div class="row solution-overview-content">
              <div class="col-4"><p class="number-solution m-0">01</p></div>
              <div class="col-8 solution-text">
                <h6 v-bind="$parent.dKey('b5array#0#title')">{{getData(0, 'title')}}</h6>
                <div v-bind="$parent.dKey('b5array#0#content')" v-html="getData(0, 'content')"></div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 wow fadeIn" data-wow-duration="2s" data-wow-delay="1s">
          <router-link :event="$root.isAdmin() ? '' : 'click'" v-bind:to="'/' + $root.locale + '/complex#high-precision-logistics'" class="solution-overview solution-02">
            <div class="row solution-overview-content">
              <div class="col-4"><p class="number-solution m-0">02</p></div>
              <div class="col-8 solution-text">
                <h6 v-bind="$parent.dKey('b5array#1#title')">{{getData(1, 'title')}}</h6>
                <div v-bind="$parent.dKey('b5array#1#content')" v-html="getData(1, 'content')"></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="row solutions-overview-wrapper">
        <div class="col-6 wow fadeIn" data-wow-duration="2s" data-wow-delay="1.25s">
          <router-link :event="$root.isAdmin() ? '' : 'click'" v-bind:to="'/' + $root.locale + '/complex#supply-chain-solutions'" class="solution-overview solution-03">
            <div class="row solution-overview-content">
              <div class="col-4"><p class="number-solution m-0">03</p></div>
              <div class="col-8 solution-text">
                <h6 v-bind="$parent.dKey('b5array#2#title')">{{getData(2, 'title')}}</h6>
                <div v-bind="$parent.dKey('b5array#2#content')" v-html="getData(2, 'content')"></div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 wow fadeIn" data-wow-duration="2s" data-wow-delay=".75s">
          <router-link :event="$root.isAdmin() ? '' : 'click'" v-bind:to="'/' + $root.locale + '/complex#warehouse-logistics'" class="solution-overview solution-04">
            <div class="row solution-overview-content">
              <div class="col-4"><p class="number-solution m-0">04</p></div>
              <div class="col-8 solution-text">
                <h6 v-bind="$parent.dKey('b5array#3#title')">{{getData(3, 'title')}}</h6>
                <div v-bind="$parent.dKey('b5array#3#content')" v-html="getData(3, 'content')"></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'LogisticServices',

  props: ['title', 'subtitle', 'bgTitle', 'services'],

  mounted() {
    if (this.$root.isAdmin()) {
      $('.solution-overview').on('click', function(event){
        event.preventDefault()
      })
    } else {
      $('.solution-overview').hover(function() {
        $(this).addClass('hover-style');
      }, function() {
        $(this).removeClass('hover-style');
      })
    }

    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  methods: {
    getData(id, key) {
      if (typeof this._props.services != 'undefined')
        return this._props.services[id][key]
      return ''
    }
  }
}

</script>

